import React from 'react'

interface LogoResultProps {
  logo: string | null | undefined
  name: string
}

export const LogoResult = ({ logo, name }: LogoResultProps) => {
  if (!logo) {
    return null
  }

  return (
    <div className="flex overflow-hidden justify-center items-center w-6 h-6 bg-white rounded-full border border-gray-200 md:w-7 md:h-7 lg:w-10 lg:h-10">
      <img src={logo} alt={name} className="object-cover" />
    </div>
  )
}
